export default __webpack_public_path__ + "static/media/shieldActive.e242d116.svg";